<template>
  <div :class="[$mq === 'sm' ? 'panel-sm' : 'panel']"
       :style="{ height: $mq === 'sm' ? '100%' : boxHeight + 'px' }">
    <div class="close" ref="close">
      <span @click="close">
        <vue-material-icon name="close" :size="32"/>
      </span>
    </div>
    <video ref="video" :src="sequence.video" controls autoplay style="width: 100%;" controlsList="nodownload"/>
    <div class="content" ref="content">
      <h3>{{ sequence.titolo }}</h3>
      <p>{{ sequence.map_abstract }}</p>
      <strong>{{ details }}</strong>
    </div>
    <!--<div class="sharing">-->
    <!--<img src="@/assets/facebook.png">-->
    <!--</div>-->

  </div>
</template>

<script>
  export default {
    name: "PanelVideo",
    props: {
      sequence: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    mounted() {
      this.boxHeight = this.$refs.close.clientHeight + (this.$refs.video.clientHeight + (window.innerWidth * 0.04)) + this.$refs.content.clientHeight
    },
    methods: {
      close() {
        this.$emit('close')
      }
    },
    data() {
      return {
        boxHeight: 0
      }
    },
    computed: {
      details() {
        let details = []
        if (this.sequence.map_author) {
          details.push(this.sequence.map_author)
        }
        if (this.sequence.map_year) {
          details.push(this.sequence.map_year)
        }
        details.push(this.sequence.reel.data.filmFormats.data.map(function (format) {
          return format.name
        }).join("/"))
        return details.join(', ')
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "../styles/variables";

  .panel {
    background-color: #fff;
    width: 50vw;
    margin-top: 10vh;
  }

  .panel-sm {
    background-color: #fff;
    width: 100vw;
    height: 100vh;
    top: 0;
  }

  .panel, .panel-sm {
    h3 {
      color: $red;
      font-weight: bold;
      margin-bottom: 0px !important;
    }

    p {
      margin-top: 10px !important;
      font-weight: 300;
      line-height: 1.3;
      color: $gray;
      text-align: justify;
    }

    strong {
      color: $gray;
    }

    img {
      width: 30px;
    }

    .content, .sharing {
      padding: 10px;
    }
  }

  .close {
    text-align: right;
    color: $red !important;

    span {
      cursor: pointer;
    }
  }

</style>
